import { render, staticRenderFns } from "./ProjectCalendar.vue?vue&type=template&id=6c9b54ae&"
import script from "./ProjectCalendar.vue?vue&type=script&lang=js&"
export * from "./ProjectCalendar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports